import React from 'react';
import { withStyles } from 'tss-react/mui';
import { ArrowBack } from '@mui/icons-material';

import { Button, ButtonProps } from '../../../Button';


const StyledNavigationBackButton = withStyles(Button, {
  root: {
    whiteSpace: 'nowrap',
  }
});

export const NavigationBackButton: React.FC<ButtonProps> = props => <StyledNavigationBackButton color="secondary" startIcon={<ArrowBack />} {...props} />;
